// extracted by mini-css-extract-plugin
export default {"card":"HowWorkCard_card__f0KH9","card-1":"HowWorkCard_card-1__3M-ML","header":"HowWorkCard_header__xswGa","number":"HowWorkCard_number__w7xgC","text":"HowWorkCard_text__2aRtQ"};